import cTitle from './cTitle.vue';

export default {
  install(Vue) {
    Vue.component('cTitle', cTitle);
  },
};
